






















































import OrderDeliverying from '@/components/order/mixins/OrderDeliverying';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';

import { Component, Mixins, Ref } from 'vue-property-decorator';
import {OrderStatusType} from 'supporter';
import { i18nObjectByKey} from '@/utils/i18n';
import {ncpPopup} from '@/utils/commonUtils';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';

@Component({
  components: {
    PageTitle,
    OrderContentTop,
    ItemTable,
  }
})
export default class OrderListDeliveryIng extends Mixins(OrderDeliverying, OrderGridBrokenFreeGiftMixin) {
  @Ref('gridBottom')
  private readonly gridRef: ItemTable;

  private orderListContent: any = [];
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private theExcelDownInfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private request: any = {
    params: {}
  };
  private searchDateTypeData: any[] = [
    {value: 'STATE_CHANGE_YMDT', name: 'ORDER_ORDER_CONTENT_TOP_DELIVERYING_STATE_CHANGE_YMDT'},
    {value: 'ORDER_YMDT', name: 'ORDER_ORDER_CONTENT_TOP_DELIVERYING_ORDER_YMDT'}
  ];
  private exchangeHelpData: any = {
    id: 'exchangeHelp',
    width: 500,
    title: 'ORDER_LIST_GRIDS_PAY_DONE_LAYER_TITLE',
    nonFooter: true
  };
  private memberGroupData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    nonFooter: false,
    hasConfirmBtn: false
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  public ifExchange: boolean = false;
  private contentBottomOption: any = {
    gridName: 'ORDER_DELIVERY_ING_GRID',
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    excelDownInfo: {
      columns: {},
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    }
  };

  private created(): void {
    this.exchangeHelpData = i18nObjectByKey(this, this.exchangeHelpData, 'title');
    this.memberGroupData = i18nObjectByKey(this, this.memberGroupData, 'title');
  }

  private mounted(): void {
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    // $('body').on('click', '.changeStatusGroup', $.proxy(this.changeStatusBtnClick, this));
    $('body').on(
      'click',
      '#exchangeHelpBtn',
      $.proxy(() => {
        this.ifExchange = true;
      }, this)
    );
    $('body').on(
      'click',
      // eslint-disable-next-line quotes
      '.tui-grid-content-area input[name="_checked"]',
      $.proxy(this.checkGroupRow, this)
    );
  }

  private destroyed(){
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    // $('body').off('click', '.changeStatusGroup', $.proxy(this.changeStatusBtnClick, this));
    $('body').off(
      'click',
      '#exchangeHelpBtn',
      $.proxy(() => {
        this.ifExchange = true;
      }, this)
    );
    $('body').off(
      'click',
      '.tui-grid-content-area input[name="_checked"]',
      $.proxy(this.checkGroupRow, this)
    );
  }

  private checkGroupRow(ev: any): void {
    let beforeCheck = this.getCheckedRowKeys();

    setTimeout(() => {
      this.$nextTick(() => {
        let afterRow = this.getCheckedRowKeys();

        let checkRow: any = [];
        if (ev.currentTarget.checked) {
          checkRow = afterRow.filter((item: any): any => {
            if (beforeCheck.length === 0) {
              return item;
            } else {
              if (beforeCheck.indexOf(item) < 0) {
                return item;
              }
            }
          });
        } else {
          checkRow = beforeCheck.filter((item: any): any => {
            if (afterRow.indexOf(item) < 0) {
              return item;
            }
          });
        }
        let row: any = [];
        checkRow.map((cr: any): any => {
          row.push(this.getRowItems(cr));
        });

        row.forEach((item1: any): any => {
          this.orderListContent.forEach((item2: any): any => {
            if (item2.shippingNo === item1.shippingNo) {
              if (ev.currentTarget.checked) {
                this.checks(item2.orderProductOptionNo);
              } else {
                this.uncheck(item2.orderProductOptionNo);
              }
            }
          });
        });
      });
    }, 0);
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse(
      $(e.target)
        .data('json')
        .replace(/\\\"/g, '"')
    );
    this.showMemberGroup = true;
  }

// LINK: src/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue
  protected changeOrderStatus(items, nextOrderStatus) {
    this.changeStatusProc(nextOrderStatus, [ ...items ], false, this.gridRef, 'DELIVERY_ING', this.search);
  }

  private changeStatus(type: OrderStatusType): void {
    if (this.getCheckedRowKeys().length === 0) {
      if (type === 'PAY_DONE') {
        alert(this.$t('ORDER_LIST_GRIDS_DEPOSIT_NOT_CHECK_ROW_ALERT'));
      } else {
        alert(this.$t('ORDER_LIST_GRIDS_NOT_CHECK_ROW_ALERT'));
      }
      return;
    }

    if (!confirm(this.$t('ORDER_LIST_GRIDS_CONFIRM_HANDLE_CHANGE') as string)) {
      return;
    }

    const checkList: any = this.getCheckedRows();
    this.changeStatusProc(type, checkList, true, this.$refs.gridBottom, 'DELIVERY_ING', this.search);
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
  }

  private initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });
    this.contentBottomOption.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.contentBottomOption.excelDownInfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.contentBottomOption.excelDownInfo.formatters = this.excelDownInfo.formatters;
    this.contentBottomOption.excelDownInfo.fileName = 'order_shipped_';
  }

  private handleSearch(e: any, page: number = 1): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.request.params.orderStatusType = 'DELIVERY_ING';
    this.request.params.partnerNo = Number(e.partnerNo);

    this.request.params.page = page || 1;
    this.request.params.size = this.size;
    $('#loading').show();
    this.$api
      .getOrderOptionsDeliveryGrid(this.request)
      .then(res => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'deliveryOrderGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = [
            'deliveryExternalKey',
            'shippingNo',
            'deliveryMemo',
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'procBtn',
            'deliveryAmtInAdvanceYn',
            'remoteDeliveryAmt',
            'orderRegisterType',
            'reservation',
            'memberGroupInfoJson',
            'procEachBtn',
            'lastSubPayAmt',
            'lastMainPayAmt',
          ];
          let midRow = ['mallNo', 'payType', 'platformType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

					const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'shippingNo', 'orderNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent, this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }

  private handleCancel(): void {}

  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    this.request.params.orderStatusType = 'DELIVERY_ING';
    this.request.params.page = page;
    this.request.params.size = size || this.initPageSize;
    $('#loading').show();
    this.$api
      .getOrderOptionsDeliveryGrid(this.request)
      .then(res => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(content, 'deliveryOrderGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
          let bigRow = [
            'deliveryExternalKey',
            'shippingNo',
            'deliveryMemo',
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'customsIdNumber',
            'deliveryType',
            'deliveryCompanyType',
            'invoiceNo',
            'procBtn',
            'deliveryAmtInAdvanceYn',
            'remoteDeliveryAmt',
            'orderRegisterType',
            'reservation',
            'memberGroupInfoJson',
            'procEachBtn',
            'lastSubPayAmt',
            'lastMainPayAmt',
          ];
          let midRow = ['mallNo', 'payType', 'platformType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'];
          let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	        const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		        small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	        }

          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'shippingNo', 'orderNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent, this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.size;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
  }

  private getCheckedItems(arr: any): any {
    return (this.$refs.gridBottom as any).getCheckedItems(arr);
  }

  private getCheckedRowKeys(): any {
    return (this.$refs.gridBottom as any).getCheckedRowKeys();
  }
  private getCheckedRows(): any {
    return (this.$refs.gridBottom as any).getCheckedRows();
  }
  private getRowItems(rowKey: any): any {
    return (this.$refs.gridBottom as any).getRowItems(rowKey);
  }
  private checks(rowKey: any): any {
    return (this.$refs.gridBottom as any).check(rowKey);
  }
  private uncheck(rowKey: any): any {
    return (this.$refs.gridBottom as any).uncheck(rowKey);
  }
}
